import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  private baseUrl = environment.uriHost;

  constructor(private http: HttpClient) {
  }

  new_POST(url: string, body: any) : Observable<any> {
    return this.http.post(`${this.baseUrl}/${url}`, body);
  }

  new_GET(url: string, id?: string | number) : Observable<any> {
    let apiUrl = id ? `${this.baseUrl}/${url}/${id}` : `${this.baseUrl}/${url}`;
    return this.http.get(apiUrl);
  }
}
